<template>
  <div id="app">
    <!-- 添加 :class 绑定，根据 isScrolled 状态切换样式 -->
    <site-header :class="{ 'scrolled': isScrolled }" />
    <router-view />
  </div>
</template>

<script>
import SiteHeader from '@/components/Header.vue'

export default {
  name: 'App',
  components: {
    SiteHeader
  },
  data() {
    return {
      isScrolled: false
    };
  },
  created() {
    this.getUrl();
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 当页面滚动时，根据滚动位置设置 isScrolled 的值
      this.isScrolled = window.scrollY > 0;
    },
    getUrl() {
      var host = window.location.host
      if (host == "www.xinerguanming.com") {
        window.location.href = 'https://www.jiexingchejia.com';
      }
    }
  }
};
</script>

<style lang="scss">
@import "./assets/style/publicProduct.scss";
a{
  text-decoration: none;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

#app {
  min-height: 100vh;
}

.header {
  position: fixed;
  width: 100%;
  z-index: 999;
  //设置白色背景色
  background-color: rgb(255, 255, 255,0.08);

  transition: background-color 0.3s ease; // 添加过渡效果
}

// 滚动后去掉 header 样式
.header.scrolled {
  background: rgba(255, 255, 255, 1);
  color: rgba(0, 46, 166, 1);
}

.scrolled .nav a {
  color: rgba(0, 46, 166, 1) !important;
  padding-bottom: 5px;
  &.router-link-active {
    color: rgba(0, 46, 166, 1) !important;
    background-image: url('@/assets/lineblue.png') !important;
    background-repeat: no-repeat;
    background-size: 50% 2px;
    background-position: 50% bottom;
  }
}


.scrolled .header-left .logo {
  background-image: url('@/assets/logoblack.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.scrolled .auth-buttons button.register {
  border: 1px solid #1A237E !important;
}
</style>
